// todo: 
// - při přechodu na vyšší verzi, hypoteticky 491 / 492 by bylo fajn upravit cesty(paths),
//   jednotlivých uživ. nastavení

namespace Gordic.Epk.AppSettings {

	/**
	 * uživatelské nastavení pro EPK05
	 * 
	 * @returns {Forms.Form}
	 */
	export function EpkForm(opt): Forms.Form {

		var Form = new Gordic.Forms.Form({
			name: "NameFormNotification",
			tabOptions: {
				title: "jres:32000859", //RC 32000859 : Nastavení EPK
				opened: false
            }
		});

		//#region --- NOTIFIKACE ---

		Form
			.addSection("jres:32000962") //RC 32000962 : Notifikace

		Form
			.addRow().addField("gcheck", {
				name: "CheckNotification",
				label: "jres:32000917",												//RC 32000917 : Skrýt notifikace při spuštění modulu EPK
				model: "Global.Epk.AppSettings.CheckNotification=value"
			});

		//#endregion

		//#region --- ÚVODNÍ POČTY ---

		Form
			.addSection("jres:32000912") //RC 32000912 : Úvodní počty

		Form
			.addRow().addField("gcheck", {
				name: "ModulInfo",
				label: "jres:32000915",												//RC 32000915 : Skrýt přehled "Modul"
				tooltip: "jres:32000957",											//RC 32000957 : Jedná se o úvodní (první) kartu modulu obsahující informace o typu modulu, přihlášeném uživatele a posledním přihlášení.
				model: "Global.Epk.AppSettings.ModulInfo=value"
			})

		Form
			.addRow().addField("gcheck", {
				name: "DisableOverviewRequestEpk",
				label: "jres:32000956",												//RC 32000956 : Skrýt přehled "Žádá v EPK"
				model: "Global.Epk.AppSettings.DisableOverviewRequestEpk=value"
			});

		Form
			.addRow().addField("gcheck", {
				name: "DisableOverviewLastUsed",
				label: "jres:32000955",												//RC 32000955 : Skrýt přehled "Posledně použité"
				model: "Global.Epk.AppSettings.DisableOverviewLastUsed=value"
			});


		//#endregion


		//#region -- PŘEHLED K VYŘÍZENÍ --

		Form
			.addSection('Úvodní počty: Přehled "Vyřizuje v EPK"');

		Form
			.addRow().addField("gcheck", {
				name: "DisableOverviewSettlementEpk",
				label: "jres:32000954",												//RC 32000954 : Skrýt přehled "Vyřizuje v EPK"
				model: "Global.Epk.AppSettings.DisableOverviewSettlementEpk=value"
			});

		Form
			.addRow({ label: "jres:32000974" }) //RC 32000974 : K vyřízení
			.addField("gnumberbox", {
				name: "ToSettlementIndex",
				model: "Global.Epk.AppSettings.SettlementPanel.ToSettlementIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000975" //RC 32000975 : Nejnižší index je v nabídce první.
			})
			.addField("gcheck", {
				name: "ToSettlementHide",
				label: "jres:32000976",										//RC 32000976 : Skrýt
				model: "Global.Epk.AppSettings.SettlementPanel.ToSettlementHide=value",
				customClass: "w-11"
			})

		Form
			//RC 32000977 : Vráceno k přepracování
			.addRow({ label: "jres:32000977", hint: "jres:32000983" })  //RC 32000983 : Zamítnuto
			.addField("gnumberbox", {
				name: "RejectedIndex",
				model: "Global.Epk.AppSettings.SettlementPanel.RejectedIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000975" //RC 32000975 : Nejnižší index je v nabídce první.
			})
			.addField("gcheck", {
				name: "RejectedHide",
				label: "jres:32000976",										//RC 32000976 : Skrýt
				model: "Global.Epk.AppSettings.SettlementPanel.RejectedHide=value",
				customClass: "w-11"
			})

		Form
			//RC 32000978 : Historie vyřízení
			.addRow({ label: "jres:32000978", hint: "jres:32000984" })  //RC 32000984 : Dříve pojmenováno Posouzeno/Schváleno. 
			.addField("gnumberbox", {
				name: "SettlementHistoryIndex",
				model: "Global.Epk.AppSettings.SettlementPanel.SettlementHistoryIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000975" //RC 32000975 : Nejnižší index je v nabídce první.
			})
			.addField("gcheck", {
				name: "SettlementHistoryHide",
				label: "jres:32000976",										//RC 32000976 : Skrýt
				model: "Global.Epk.AppSettings.SettlementPanel.SettlementHistoryHide=value",
				customClass: "w-11"
			})

		Form
			.addRow("jres:32000979") //RC 32000979 : Nevyřízeno před termínem
			.addField("gnumberbox", {
				name: "BeforeToSettlementIndex",
				model: "Global.Epk.AppSettings.SettlementPanel.BeforeToSettlementIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000975" //RC 32000975 : Nejnižší index je v nabídce první.
			})
			.addField("gcheck", {
				name: "BeforeToSettlementHide",
				label: "jres:32000976",										//RC 32000976 : Skrýt
				model: "Global.Epk.AppSettings.SettlementPanel.BeforeToSettlementHide=value",
				customClass: "w-11"
			})

		Form
			.addRow("jres:32000980") //RC 32000980 : Nevyřízeno těsně před termínem
			.addField("gnumberbox", {
				name: "JustBeforeToSettlementIndex",
				model: "Global.Epk.AppSettings.SettlementPanel.JustBeforeToSettlementIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000975" //RC 32000975 : Nejnižší index je v nabídce první.
			})
			.addField("gcheck", {
				name: "JustBeforeToSettlementHide",
				label: "jres:32000976",										//RC 32000976 : Skrýt
				model: "Global.Epk.AppSettings.SettlementPanel.JustBeforeToSettlementHide=value",
				customClass: "w-11"
			})

		Form
			.addRow("jres:32000981") //RC 32000981 : Nevyřízeno po termínu
			.addField("gnumberbox", {
				name: "AfterToSettlementIndex",
				model: "Global.Epk.AppSettings.SettlementPanel.AfterToSettlementIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000975" //RC 32000975 : Nejnižší index je v nabídce první.
			})
			.addField("gcheck", {
				name: "AfterToSettlementHide",
				label: "jres:32000976",										//RC 32000976 : Skrýt
				model: "Global.Epk.AppSettings.SettlementPanel.AfterToSettlementHide=value",
				customClass: "w-11"
			})

		//#endregion


		//#region --- MOBIL ---

		Form
			.addSection("jres:32000960") //RC 32000960 : Mobilní zobrazení


		Form
			.addRow().addField("gcheck", {
				name: "CardDisplay",
				label: "jres:32000958",												//RC 32000958 : Zapnout mobilní zobrazení pro dialog úvodních počtů
				tooltip: "jres:32000959", //RC 32000959 : Úvodní počty se zobrazí jako panel karet
				model: "Global.Epk.AppSettings.CardDisplay=value"
			});

		Form
			.addRow().addField("gcheck", {
				name: "CardGrid",
				label: "jres:32000916",												//RC 32000916 : Zapnout mobilní zobrazení pro seznam "K vyřízení"
				model: "Global.Epk.AppSettings.CardGrid=value"
			});

		Form
			.addRow()
			.addText("jres:32001064"); //RC 32001064 : Nastavení mobilního zobrazení přes webconfig má vyšší prioritu než přes uživatelské nastavení.

		//Form
		//	.addRow().addField("gcheck", {
		//		name: "MobileGridProfile",
		//		label: "jres:32000993",												//RC 32000993 : Zapnout mobilní profil pro seznamy v EPK
		//		tooltip: "jres:32000994", //RC 32000994 : Neplatí pro seznamy zobrazené jako karty
		//		model: "Global.Epk.AppSettings.MobileGridProfile=value"
		//	});

		//#endregion

		//#region --- PALETA BAREV ---

		Form
			.addSection("jres:32001071") //RC 32001071 : Barevné označení žádostí v EPK

		Form
			.addRow("jres:32000885") //RC 32000885 : Uživatelský název přehledu barev
			.addField("gstringbox", {
				name: "NameColorbar",
				model: "Global.Epk.AppSettings.NameColorbar=value",
				customClass: "w-6"
			})
			.addField("gcheck", {
				name: "ColorbarPrimary",
				label: "jres:32000886",										//RC 32000886 : Primární
				tooltip: "jres:32000887",									//RC 32000887 : Primární zobrazení v rámci přehledu
				model: "Global.Epk.AppSettings.ColorbarPrimary=value",
				customClass: "w-6"
			})

		Form
			.addRow().addField("gcheck", {
				name: "ShowColor",
				label: "jres:32000870",										//RC 32000870 : Zobrazit přehled barev
				model: "Global.Epk.AppSettings.ShowColor=value",
			})

			.addRow().addField("gcheck", {
				name: "ShowOnlyFillColor",
				label: "jres:32000871",										//RC 32000871 : Zobrazit pouze vyplněné barvy
				model: "Global.Epk.AppSettings.ShowOnlyFillColor=value",
			})

			.addRow().addField("gcheck", {
				name: "ShowOnlyUserLabelColor",
				label: "jres:32000872",										//RC 32000872 : Zobrazit pouze uživatelsky pojmenované barvy
				model: "Global.Epk.AppSettings.ShowOnlyUserLabelColor=value",
			})

		//#region -- BARVY --

		Form
			.addRow("jres:32000873")
			.addField("gstringbox", { //RC 32000873 : Červená
				name: "Red",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.Red=value",
				customClass: "w-5"
			})
			.addField("gnumberbox", {
				name: "RedIndex",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.RedIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000953" //RC 32000953 : Pořadí
			})
			.addField("gcheck", {
				name: "CheckAllRed",
				label: "jres:32000882",										//RC 32000882 : Automaticky označit vše
				model: "Global.Epk.AppSettings.CheckAll.Red=value",
				customClass: "w-6"
			})

			.addRow("jres:32000874")
			.addField("gstringbox", { //RC 32000874 : Zelená
				name: "Green",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.Green=value",
				customClass: "w-5"
			})
			.addField("gnumberbox", {
				name: "GreenIndex",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.GreenIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000953" //RC 32000953 : Pořadí
			})
			.addField("gcheck", {
				name: "CheckAllGreen",
				label: "jres:32000882",										//RC 32000882 : Automaticky označit vše
				model: "Global.Epk.AppSettings.CheckAll.Green=value",
				customClass: "w-6"
			})

			.addRow("jres:32000875")
			.addField("gstringbox", { //RC 32000875 : Modrá
				name: "Blue",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.Blue=value",
				customClass: "w-5"
			})
			.addField("gnumberbox", {
				name: "BlueIndex",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.BlueIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000953" //RC 32000953 : Pořadí
			})
			.addField("gcheck", {
				name: "CheckAllBlue",
				label: "jres:32000882",										//RC 32000882 : Automaticky označit vše
				model: "Global.Epk.AppSettings.CheckAll.Blue=value",
				customClass: "w-6"
			})

			.addRow("jres:32000876")
			.addField("gstringbox", { //RC 32000876 : Fialová
				name: "Purple",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.Purple=value",
				customClass: "w-5"
			})
			.addField("gnumberbox", {
				name: "PurpleIndex",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.PurpleIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000953" //RC 32000953 : Pořadí
			})
			.addField("gcheck", {
				name: "CheckAllPurple",
				label: "jres:32000882",										//RC 32000882 : Automaticky označit vše
				model: "Global.Epk.AppSettings.CheckAll.Purple=value",
				customClass: "w-6"
			})

			.addRow("jres:32000877")
			.addField("gstringbox", { //RC 32000877 : Žlutá
				name: "Yellow",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.Yellow=value",
				customClass: "w-5"
			})
			.addField("gnumberbox", {
				name: "YellowIndex",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.YellowIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000953" //RC 32000953 : Pořadí
			})
			.addField("gcheck", {
				name: "CheckAllYellow",
				label: "jres:32000882",										//RC 32000882 : Automaticky označit vše
				model: "Global.Epk.AppSettings.CheckAll.Yellow=value",
				customClass: "w-6"
			})

			.addRow("jres:32000878")
			.addField("gstringbox", { //RC 32000878 : Bílá
				name: "White",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.White=value",
				customClass: "w-5"
			})
			.addField("gnumberbox", {
				name: "WhiteIndex",
				model: "Global.Epk.AppSettings.OthersSettings.GColorPicker.WhiteIndex=value",
				customClass: "w-1",
				tooltip: "jres:32000953" //RC 32000953 : Pořadí barev. Nejnižší index je v nabídce první.
			})
			.addField("gcheck", {
				name: "CheckAllWhite",
				label: "jres:32000882",										//RC 32000882 : Automaticky označit vše
				model: "Global.Epk.AppSettings.CheckAll.White=value",
				customClass: "w-6"
			})


		//#endregion

		//#endregion

		//#region --- VYŘÍZENÍ ---

		Form
			.addSection("jres:32000913") //RC 32000913 : Vyřízení

		Form
			.addRow().addField("gcheck", { 
				name: "FastMultiSettlement",
				label: "jres:32000868",										//RC 32000868 : Zapnout rychlé hromadné vyřízení
				tooltip: "jres:32000961",									//RC 32000961 : Povoleno v klasickém (nemobilním) zobrazení
				model: "Global.Epk.AppSettings.FastMultiSettlement=value"
			})

		Form
			.addRow().addField("gcheck", {					
				name: "AutoDetailRun",
				label: "jres:32000918",										//RC 32000918 : Zapnout automatické otevření dalšího detailu žádosti po vyřízení předchozí žádosti
				model: "Global.Epk.AppSettings.AutoDetailRun=value"
			});

		Form
			.addRow().addField("gcheck", {
				name: "FiltersGridSettings",
				label: "jres:32000919",										//RC 32000919 : Vypnout zapamatování poslední hodnoty filtrů na seznamech
				model: "Global.Epk.AppSettings.FiltersGridSettings=value"
			});

		//#endregion

		var scrollData: Gordic.Components.FilePreview.GPdfEngineScrollMode[] = [Gordic.Components.FilePreview.GPdfEngineScrollMode.Vertical, Gordic.Components.FilePreview.GPdfEngineScrollMode.Horizontal, Gordic.Components.FilePreview.GPdfEngineScrollMode.Wrapped];

		Form
			.addSection("jres:32000995") //RC 32000995 : Náhledy

		Form
			.addRow("jres:32001001") //RC 32001001 : Typ posuvu
			.addField("gselectbox", {
				name: "scrollMode",
				data: scrollData,
				dropdown: true,
				itemTemplate: (value) => {
					if (value === Gordic.Components.FilePreview.GPdfEngineScrollMode.Vertical)
						return "jres:32001000"; //RC 32001000 : Vertikální posouvání
					else if (value === Gordic.Components.FilePreview.GPdfEngineScrollMode.Horizontal)
						return "jres:32000999"; //RC 32000999 : Vodorovné posouvání
					else if (value === Gordic.Components.FilePreview.GPdfEngineScrollMode.Wrapped)
						return "jres:32000998"; //RC 32000998 : Postupné posouvání
					else
						return "jres:32001002" //RC 32001002 : Neurčeno
				},
				model: "Global.Epk.AppSettings.ScrollMode=value"
			})

		return Form;

	}

}
